import { computed } from 'vue'
import { storeToRefs } from 'pinia'
import { useAuthStore } from '@/stores/auth'
import { usePermissions } from '@/stores/permissions'

const TEAM_MANAGEMENT_USER_TYPES = ['User', 'Organizador']

export function useUserType() {
  const { user } = storeToRefs(useAuthStore())
  const { userPermissions } = storeToRefs(usePermissions())

  const userType = computed(() => user.value?.user_type ?? null)

  const canAccessTeamManagement = computed(() => {
    const type = userType.value?.toLowerCase() ?? ''
    return (
      TEAM_MANAGEMENT_USER_TYPES.map((t) => t.toLowerCase()).includes(type) &&
      userPermissions.value.canManageTeam
    )
  })

  return {
    userType,
    canAccessTeamManagement,
  }
}
